<template>
  <a-menu id="menu-div" :openKeys="openKeys" :selectedKeys="selectedKeys"
    :style="{ 'width': collapsed ? '80px' : '220px', 'height': '100%', 'font-size': '16px' ,'background':'#0f5abe','color':'#ffffff'}" mode="inline" :inline-collapsed="collapsed">
    <div v-for="(item, index) in routerArr" :key="index">
      <item-menu :item="item" :basePath="item.path" ></item-menu>
    </div>
  </a-menu>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ItemMenu from './ItemMenu.vue'

defineProps(['collapsed'])
const router = useRouter()
const routerArr = router.options.routes // 获取所有路由信息用于渲染主菜单
const currentRoute = useRoute() // 当前路由
const selectedKeys = computed(() => {
  const arr: string[] = []
  currentRoute.matched.forEach(el => {
    arr.push(el.path)
  });
  return arr
})
const openKeys = computed(() => {
  const arr: string[] = []
  currentRoute.matched.forEach(el => {
    arr.push(el.path)
  });
  return arr
})

</script>
<style lang="stylus" scoped>
.ant-menu .svg-icon {
  font-size: 22px
}
.collapsed {
  text-align: right 
  font-size: 20px
  position relative
  bottom: 0
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon {
  font-size: 22px;
}
.ant-menu-item-selected .ant-menu-item-icon  {
  fill: #ffae00;
  background: #ffae00;
  border: 1px solid red;
}

</style>

